import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'next/router';
import { Button } from '../../Generic/Button';
import styles from './Header-tw-styles';
import Menustyles from '../Menu/Menu-tw-styles';
import { getCdnImage } from '../../../utils/ImageManager';

import i18nMessages from '../../../constants/messages/pt-BR';
// eslint-disable-next-line react/destructuring-assignment
import NavigationDesktop from '../Menu/NavigationDesktop';
import constants from '../Search/constants';
// eslint-disable-next-line react/destructuring-assignment

const CountrySelector = dynamic(() => import('../CountrySelector'));
const NavigationMobile = dynamic(() => import('../Menu/NavigationMobile'));

class Header extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false,
      showCountry: false,
      widthVar: null,
      showdropdownPopup: false,
    };
  }
  componentDidMount() {
    this.setState({ widthVar: window.innerWidth });
    window.addEventListener(i18nMessages.resize, this.resetOnResize);
    const { userStore } = this.props;
    userStore.init();
  }

  componentWillUnmount() {
    window.removeEventListener(i18nMessages.resize, this.resetOnResize);
  }

  resetOnResize = () => {
    const { widthVar } = this.state;
    if (widthVar !== window.innerWidth) {
      this.setState({
        isMenuOpen: false,
        showCountry: false,
        widthVar: window.innerWidth,
      });
    }
  };

  handleCountryShow = () => {
    this.setState(prevState => ({ showCountry: !prevState.showCountry }));
    document.body.classList.toggle(i18nMessages.freezebody); // Toggle class for BODY when menu opened
  };

  handleClick = () => {
    document.body.classList.toggle(i18nMessages.freezebody); // Toggle class for BODY when menu opened
    this.setState(
      prevState => ({ isMenuOpen: !prevState.isMenuOpen }),
      () => {
        this.isMenuOpenClasses();
      }
    );
  };
  isMenuOpenClasses = () => {
    const { isMenuOpen } = this.state;
    const menuDiv = document.getElementById(i18nMessages.menuopenbar);
    const body = document.getElementsByTagName(i18nMessages.body);
    if (isMenuOpen) {
      menuDiv && menuDiv.classList.add(i18nMessages.menuopened);
      body[0].classList.add(i18nMessages.overflowhidden);
    } else {
      menuDiv && menuDiv.classList.remove(i18nMessages.menuopened);
      body[0].classList.remove(i18nMessages.overflowhidden);
    }
  };

  handleLoginClick = () => {
    const { showdropdownPopup } = this.state;
    this.setState({ showdropdownPopup: !showdropdownPopup });
  };

  render() {
    // header data from Contentful
    const { headerData, locale, toggleShowHide, isSearchExpanded, userStore } = this.props;
    const { isMenuOpen, showdropdownPopup, showCountry, widthVar } = this.state;

    return (
      <header id="page-header" className={classNames(styles.header)}>
        <div className={classNames(styles.container)}>
          <div className={classNames(styles.headerWrapper)}>
            <div className={classNames(styles.menuBar.logoContainer)}>
              <div className={classNames(styles.menuBar.logoDiv)}>
                <div className={classNames(styles.hambergerContainer)}>
                  <button
                    type="button"
                    className={classNames(styles.hambergerButton)}
                    onClick={() => {
                      this.handleClick();
                    }}
                    aria-label="Abrir menu de navegação"
                    aria-expanded={this.state.isMenuOpen}
                    role="button"
                    aria-roledescription=" "
                  >
                    <div className={classNames(styles.hambergerBar)} />
                    <div className={classNames(styles.hambergerBar)} />
                    <div className={classNames(styles.hambergerBar)} />
                  </button>
                </div>
                {headerData && headerData.brandLogo && (
                  <div className={classNames(styles.menuBar.logoButton)}>
                    <Button
                      to={headerData.brandLogo.link}
                      aria-label="Logo da PANTENE"
                      tabIndex={this.state.isMenuOpen ? -1 : 0}
                    >
                      <img
                        src={getCdnImage(headerData.brandLogo.image.url)}
                        alt="Logo da PANTENE"
                      />
                    </Button>
                  </div>
                )}
                {/* for desktop */}
                <NavigationDesktop
                  styles={styles}
                  Menustyles={Menustyles}
                  headerData={headerData}
                  locale={locale}
                  handleCountryShow={this.handleCountryShow}
                  toggleShowHide={toggleShowHide}
                  isSearchExpanded={isSearchExpanded}
                  showCountry={showCountry}
                  showdropdownPopup={showdropdownPopup}
                  userStore={userStore}
                />
              </div>
            </div>
            {/* for mobile*/}
            {isMenuOpen && (
              <NavigationMobile
                handleClick={this.handleClick}
                styles={styles}
                isMenuOpen={isMenuOpen}
                headerData={headerData}
                locale={locale}
                menuClose={this.handleClick}
                loginClickHandler={this.handleLoginClick}
                userStore={userStore}
              />
            )}
          </div>
        </div>

          <div>
            <CountrySelector
              countryData={headerData.countrySelectorsCollection.items}
              show={showCountry}
              showHandler={this.handleCountryShow}
            />
          </div>
      </header>
    );
  }
}
export default withRouter(observer(Header));

Header.propTypes = {
  locale: PropTypes.string,
  headerData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  toggleShowHide: PropTypes.func.isRequired,
  isSearchExpanded: PropTypes.bool,
  userStore: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
Header.defaultProps = {
  locale: 'pt-BR',
};
